const AboutSection = () => {
  return (
    <section className="bg-white py-12">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Content */}
          <div className="space-y-6">
            {/* Main Heading */}
            <div className="space-y-2">
              <h2 className="text-4xl lg:text-5xl font-bold leading-tight">
                <span className="text-blue-500">Best</span>{' '}
                <span className="text-gray-900">Medical Billing Company</span>{' '}
                <span className="text-blue-500">in USA</span>
              </h2>
            </div>

            {/* Description Paragraphs */}
            <div className="space-y-4 text-gray-600 leading-relaxed text-base">
              <p>
                iSolve RCM is the top-rated medical billing firm that offers medical 
                billing services for multi-specialty clinics, providing the complete RCM 
                services in USA, covering eligibility verification, claim submission, denial 
                management, and payment posting for both professional and facility 
                claims using the CMS-1500 form and UB-04 (CMS-1450). Our team of 
                certified coders and professional billing teams delivers proper coding, 
                clean claims and faster reimbursement.
              </p>
              
              <p>
                Simplify your healthcare practice with professional medical billing 
                services trusted by healthcare providers across all U.S. states for over 9 
                years. Our medical billing agency is responsible for better 
                reimbursements by precise billing and ongoing account monitoring, 
                from charge capture to reporting. These strategies can reduce denials, 
                speed up reimbursements, and improve the financial health of 
                healthcare practices across USA.
              </p>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <img 
              src="/billing11.jpeg" 
              alt="Medical Billing Team" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
